import { render, staticRenderFns } from "./InquiryOrder.vue?vue&type=template&id=6ce9683e&scoped=true&"
import script from "./InquiryOrder.vue?vue&type=script&lang=js&"
export * from "./InquiryOrder.vue?vue&type=script&lang=js&"
import style0 from "./InquiryOrder.vue?vue&type=style&index=0&id=6ce9683e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9683e",
  null
  
)

export default component.exports